import { Logo } from "@/components/brand/Logo";
import { useStore } from "@/lib/store";

export const Footer = () => {
  const { openCheckout } = useStore();
  return (
    <footer data-testid="site-footer" className="bg-[#181615] text-[#F2EAE1]">
      <div className="mx-auto max-w-[1400px] px-5 pb-10 pt-20 sm:px-8">
        <div className="flex flex-col justify-between gap-10 border-b border-white/10 pb-14 lg:flex-row lg:items-end">
          <h2 className="font-display text-5xl font-light leading-[0.95] tracking-tight sm:text-7xl">
            Press slow.<br /><span className="italic text-[#E0A030]">Live golden.</span>
          </h2>
          <button data-testid="footer-buy-button" onClick={openCheckout} className="self-start rounded-full bg-[#E0A030] px-8 py-4 font-semibold text-[#181615] transition-[background-color] duration-300 hover:bg-[#F2EAE1] lg:self-auto">Claim yours — $250</button>
        </div>
        <div className="flex flex-col justify-between gap-6 pt-8 text-sm text-[#C9BFB5] sm:flex-row sm:items-center">
          <Logo dark testId="footer-logo" />
          <p>Ships from Alton, Illinois · Secure payments by Stripe</p>
          <p>© {new Date().getFullYear()} Golden Hour Press · <a href="/admin" data-testid="footer-admin-login-link" className="underline-offset-4 hover:text-[#E0A030] hover:underline">Admin login</a></p>
        </div>
      </div>
    </footer>
  );
};
